import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { adminMenu, studentMenu, teacherMenu } from "../../Data/data";
import { useLocation, useNavigate } from "react-router-dom";
import { logout } from "../../redux/reducer/authSlice";

const Sidebar = ({ isOpen, setIsOpen }) => {
  const { isLoggedIn, role } = useSelector((state) => state.auth);
  const navigate = useNavigate();
  const location = useLocation(); // current path
  const dispatch = useDispatch();

  const menu =
    role === "admin"
      ? adminMenu
      : role === "teacher"
        ? teacherMenu
        : studentMenu;

  return (
    <>
      {/* Overlay for mobile */}
      <div
        className={`sidebar-overlay ${isOpen ? "active" : ""}`}
        onClick={() => setIsOpen(false)}
      ></div>

      <div className={`sidebar ${isOpen ? "active" : ""}`}>
        <div className="heading">
          <h2>
            {role === "admin"
              ? "Admin Dashboard"
              : role === "teacher"
                ? "Teacher Dashboard"
                : "Student Dashboard"}
          </h2>
        </div>
        <div className="dashboard-items">
          {menu.map((item) => {
            const isActive = location.pathname === item.link;
            return (
              <button
                key={item.id}
                className={`dashboard-btn ${isActive ? "active" : ""}`}
                onClick={() => {
                  navigate(item.link);
                  setIsOpen(false); // close sidebar on mobile
                }}
              >
                {item.title}
              </button>
            );
          })}

          <button
            className="dashboard-btn logout"
            onClick={() => dispatch(logout())}
          >
            Logout
          </button>
        </div>
      </div>
    </>
  );
};

export default Sidebar;
